import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_4774e150 from 'nuxt_plugin_plugin_4774e150' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_0f296601 from 'nuxt_plugin_plugin_0f296601' // Source: ./composition-api/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_791b5962 from 'nuxt_plugin_pluginutils_791b5962' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_662b48da from 'nuxt_plugin_pluginrouting_662b48da' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_2e2be0d5 from 'nuxt_plugin_pluginmain_2e2be0d5' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_3260ff28 from 'nuxt_plugin_axios_3260ff28' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_moment_01cc1eac from 'nuxt_plugin_moment_01cc1eac' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_vuechart_7d19cf94 from 'nuxt_plugin_vuechart_7d19cf94' // Source: ../plugins/vue-chart.js (mode: 'client')
import nuxt_plugin_nuxtquillplugin_3ab6ceae from 'nuxt_plugin_nuxtquillplugin_3ab6ceae' // Source: ../plugins/nuxt-quill-plugin.js (mode: 'client')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'client')
import nuxt_plugin_vuecurency_0cd1faa2 from 'nuxt_plugin_vuecurency_0cd1faa2' // Source: ../plugins/vue-curency (mode: 'client')
import nuxt_plugin_numeralinject_09eb4921 from 'nuxt_plugin_numeralinject_09eb4921' // Source: ../plugins/numeral-inject.js (mode: 'client')
import nuxt_plugin_datelib_2d022f0c from 'nuxt_plugin_datelib_2d022f0c' // Source: ../plugins/injecttions/date-lib.js (mode: 'client')
import nuxt_plugin_repositories_a519ad4e from 'nuxt_plugin_repositories_a519ad4e' // Source: ../plugins/repositories.js (mode: 'client')
import nuxt_plugin_vueexcel_3b6ffa86 from 'nuxt_plugin_vueexcel_3b6ffa86' // Source: ../plugins/vue-excel.js (mode: 'client')
import nuxt_plugin_permissions_39ccd8b0 from 'nuxt_plugin_permissions_39ccd8b0' // Source: ../plugins/directives/permissions.js (mode: 'client')
import nuxt_plugin_joditvue_e73d71ac from 'nuxt_plugin_joditvue_e73d71ac' // Source: ../plugins/jodit-vue.js (mode: 'client')
import nuxt_plugin_vuetoastnotification_168bdc6e from 'nuxt_plugin_vuetoastnotification_168bdc6e' // Source: ../plugins/vue-toast-notification.js (mode: 'client')
import nuxt_plugin_lightbox_449b2fac from 'nuxt_plugin_lightbox_449b2fac' // Source: ../plugins/lightbox.js (mode: 'client')
import nuxt_plugin_persistedStateclient_3b127e9c from 'nuxt_plugin_persistedStateclient_3b127e9c' // Source: ../plugins/persistedState.client.js (mode: 'client')
import nuxt_plugin_qr_33aaeb00 from 'nuxt_plugin_qr_33aaeb00' // Source: ../plugins/qr.js (mode: 'client')
import nuxt_plugin_meta_29e1d92f from 'nuxt_plugin_meta_29e1d92f' // Source: ./composition-api/meta.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s","title":"OKXE Admin","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Material+Icons"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_4774e150 === 'function') {
    await nuxt_plugin_plugin_4774e150(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0f296601 === 'function') {
    await nuxt_plugin_plugin_0f296601(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_791b5962 === 'function') {
    await nuxt_plugin_pluginutils_791b5962(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_662b48da === 'function') {
    await nuxt_plugin_pluginrouting_662b48da(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_2e2be0d5 === 'function') {
    await nuxt_plugin_pluginmain_2e2be0d5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3260ff28 === 'function') {
    await nuxt_plugin_axios_3260ff28(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_01cc1eac === 'function') {
    await nuxt_plugin_moment_01cc1eac(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuechart_7d19cf94 === 'function') {
    await nuxt_plugin_vuechart_7d19cf94(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtquillplugin_3ab6ceae === 'function') {
    await nuxt_plugin_nuxtquillplugin_3ab6ceae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecurency_0cd1faa2 === 'function') {
    await nuxt_plugin_vuecurency_0cd1faa2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_numeralinject_09eb4921 === 'function') {
    await nuxt_plugin_numeralinject_09eb4921(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datelib_2d022f0c === 'function') {
    await nuxt_plugin_datelib_2d022f0c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_repositories_a519ad4e === 'function') {
    await nuxt_plugin_repositories_a519ad4e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueexcel_3b6ffa86 === 'function') {
    await nuxt_plugin_vueexcel_3b6ffa86(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_permissions_39ccd8b0 === 'function') {
    await nuxt_plugin_permissions_39ccd8b0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_joditvue_e73d71ac === 'function') {
    await nuxt_plugin_joditvue_e73d71ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetoastnotification_168bdc6e === 'function') {
    await nuxt_plugin_vuetoastnotification_168bdc6e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lightbox_449b2fac === 'function') {
    await nuxt_plugin_lightbox_449b2fac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedStateclient_3b127e9c === 'function') {
    await nuxt_plugin_persistedStateclient_3b127e9c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_qr_33aaeb00 === 'function') {
    await nuxt_plugin_qr_33aaeb00(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_29e1d92f === 'function') {
    await nuxt_plugin_meta_29e1d92f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
